import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "absolute z-20 top-2 right-2" }
const _hoisted_2 = { class: "absolute z-20 h-10 w-10 inset-0 m-auto" }
const _hoisted_3 = { class: "absolute z-20 h-6 w-6 bottom-2 right-2" }
const _hoisted_4 = { class: "absolute" }

import { computed, onBeforeMount, onMounted, ref } from "vue";
import HLSCore from "@cloudgeek/playcore-hls";
import { emit } from "process";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'OpeningVideo',
  emits: ["hidden"],
  setup(__props, { emit: emits }) {

const store = useStore();

const player = ref();
const width = ref<number>(0);
const height = computed<number>(() => {
  return width.value * 0.5625;
});

const isPlaying = ref<boolean>(false);
const isMuted = ref<boolean>(true);



const calculateWindowWidth = () => {
  width.value =
    window.innerWidth < 756 ? window.innerWidth : (window.innerWidth * 2) / 3;
};

const play = () => {
  player!.value.play();
};

const toggleMute = () => {
  isMuted.value = !isMuted.value;

  player.value.player.setMuted(isMuted.value);
};

const hide = () => {
  store.dispatch('markShownVideo');
};

const syncStatus = () => {
  isPlaying.value = player!.value.isPlaying;
};

const onloadeddata = () => {
  player.value.player.setMuted(true);
};

onBeforeMount(() => {
  window.addEventListener("resize", calculateWindowWidth);
});

onMounted(() => {
  calculateWindowWidth();
});

return (_ctx: any,_cache: any) => {
  const _component_fa = _resolveComponent("fa")!
  const _component_vue3_video_player = _resolveComponent("vue3-video-player")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative top-32",
    style: _normalizeStyle({ width: `${width.value}px`, height: `${height.value}px` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-gray-600 rounded-full",
        onClick: hide
      }, [
        _createVNode(_component_fa, {
          icon: "times",
          size: "lg",
          class: "absolute text-white"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (!isPlaying.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-blue-400 rounded-full",
            onClick: play
          }, [
            _createVNode(_component_fa, {
              icon: "sync-alt",
              size: "md",
              class: "absolute text-white"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "relative inline-flex items-center justify-center w-6 h-6 overflow-hidden bg-blue-400 rounded-full",
        onClick: toggleMute
      }, [
        (isMuted.value)
          ? (_openBlock(), _createBlock(_component_fa, {
              key: 0,
              icon: "volume-mute",
              size: "sm",
              class: "absolute text-white"
            }))
          : _createCommentVNode("", true),
        (!isMuted.value)
          ? (_openBlock(), _createBlock(_component_fa, {
              key: 1,
              icon: "volume-up",
              size: "sm",
              class: "absolute text-white"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_vue3_video_player, {
        ref_key: "player",
        ref: player,
        class: "absolute",
        core: _unref(HLSCore),
        src: "https://terraspace-dev.net/opening/opening.m3u8",
        width: width.value,
        controls: false,
        muted: false,
        onPlay: syncStatus,
        onEnded: syncStatus,
        onLoad: syncStatus,
        onLoadeddata: onloadeddata
      }, null, 8, ["core", "width"])
    ])
  ], 4))
}
}

})